import React from 'react';
import { FaBug } from "react-icons/fa";

import classes from './BugReportButton.module.scss';

const BugReportButton = (props) => {
    return (
        <React.Fragment>
            <button id={'bugReportButtonId'} className={`${classes.bugReportButton} BugReportButton_button`} onClick={() => props.getImage ? props.getImage() : {}}>
                <FaBug size={21}/>
                <div>Сообщить об ошибке</div>
            </button>
            <button id={'mobileBugReportButtonId'} className={`${classes.mobileBugReportButton} MobileBugReportButton_button`} onClick={() => props.getImage ? props.getImage() : {}} aria-label="send bug report">
                <FaBug id={'mobileBugReportButtonFaBugId'} size={23}/>
            </button>
        </React.Fragment>
    )
}

export default BugReportButton;
